import {Form as AntForm} from 'antd';
import React, {useEffect, useMemo} from 'react';

import Form from '../../../../components/Form/Form';
import MobileModalForm from '../../../../components/Form/MobileModalForm';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import * as modalTypes from '../../../../consts/modals/modalTypes';
import useIsMobileViewport from '../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import log from '../../../../services/logger/log';
import helpers from '../../../../utils/helpers';
import organizationModalService from './organizationModalService';

const OrganizationModal = ({modalType, onCancel}) => {
    const isMobile = useIsMobileViewport();
    const [form] = AntForm.useForm();
    const localizedStrings = getLocalizedStrings();

    // Keep edited values when switching between the mobile and desktop layouts.
    const modalProps = useMemo(() => organizationModalService.getModalProps(modalType), [modalType]);
    const formFields = organizationModalService.getFormFields(modalProps);
    const {title, initialValues, onSubmit, submitBtnText} = modalProps || {};
    const usesMobileOrganizationLayout = [
        modalTypes.ORGANIZATION_CREATE_MODAL,
        modalTypes.ORGANIZATION_EDIT_MODAL,
        modalTypes.ORGANIZATION_COPY_MODAL,
    ].includes(modalType);

    useEffect(() => {
        if (!usesMobileOrganizationLayout) return undefined;

        document.body.classList.add('organization-create-modal-open');

        return () => document.body.classList.remove('organization-create-modal-open');
    }, [usesMobileOrganizationLayout]);

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues]);

    const handleSelect = (value, name) => {
        form.setFieldsValue({[name]: value});
    };

    const closeModal = () => {
        helpers.runFunction(onCancel);
        form.resetFields();
    };

    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            helpers.runFunction(onSubmit, values);
            closeModal();

            form.resetFields();
        } catch (info) {
            log.info('Validate Failed:', info);
        }
    };
    const handleRadioChange = (value, name) => {
        form.setFieldsValue({[name]: value});
    };

    const handleChange = () => {};

    if (isMobile) {
        return (
            <MobileModalForm
                form={form}
                formName={`organization-mobile-${modalType}`}
                className='organization-mobile-form'
                title={title}
                closeLabel={localizedStrings[localizationKeys.ORGS_PAGE_MOBILE_CLOSE_FORM]}
                formFields={formFields}
                initialValues={initialValues}
                onFinish={handleOk}
                onCancel={closeModal}
                submitButton={submitBtnText}
                cancelButton={localizedStrings[localizationKeys.ORGS_PAGE_MODAL_FORM_CANCEL_BTN_TEXT]}
                handleRadioChange={handleRadioChange}
                handleSelect={handleSelect}
                handleChange={handleChange}
            />
        );
    }

    return (
        <Form
            handleRadioChange={handleRadioChange}
            handleSelect={handleSelect}
            closeModal={onCancel}
            initialValues={initialValues}
            submitButton={submitBtnText}
            onFinish={handleOk}
            title={title}
            formFields={formFields.map((field) => ({...field, preserve: true}))}
            cancelButton={localizedStrings[localizationKeys.ORGS_PAGE_MODAL_FORM_CANCEL_BTN_TEXT]}
            formInstance={form}
            handleChange={handleChange}
            formClassName={usesMobileOrganizationLayout ? 'organization-create-form' : undefined}
            containerClassName={usesMobileOrganizationLayout ? 'organization-create-form-content' : undefined}
            buttonsClassName={usesMobileOrganizationLayout ? 'organization-create-form-actions' : undefined}
        />
    );
};

export default OrganizationModal;
